import React, { Component, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { isLoggedIn } from "../../utils/BeeApi";
import {
  isBDCLoggedIn,
  isClientLoggedIn,
  isLoggedIn as isLoggedInDE,
  isPgmLoggedIn,
} from "../../utils/DeApi";
import bdcUserContext from "../contextServices/bdcUserContext";
import ForgotPassword from "./ForgotPassword/ForgotPassword";
import ResetPassword from "./ResetPassword/ResetPassword";
import Login from "./Login/Login";
import Logout from "./Logout/Logout";
import Dashboard from "../Dashboard/Dashboard";
import Search from "../Search/Search";
import OptimizedSearch from "../OptimizedSearch/OptimizedSearch";
import Catalogue from "../Catalogue/Catalogue";
import FormTypes from "../FormTypes/FormTypes";
import { isDevelopment } from "../../utils/env";
import KeywordList from "../KeywordLists/KeywordList";
import BdcDashboard from "../BdcDashboard/Dashboard";
import ClientDashboard from "../ClientDashboard/ClientDashboard";
import FormFiling from "../Filing/FormFilings/FormFiling";
import BdcForm from "../BdcDashboard/BdcForm";
import moment from "moment";
import "./App.scss";
import LoanDocumentFetch from "../LoanDocumentFetch/LoanDocumentFetch";
import CikList from "../CikLists/CikList";
import { Toaster } from "react-hot-toast";
import { KeywordListPgm } from "../KeywordLists/KeywordListPgm";
import OptimizedSearchPgm from "../OptimizedSearch/OptimizedSearchPgm";
import PGMDashboard from "../PgmDashboard/Dashboard";

/**
 * Handles application level routing.
 * It sets a middleware for private and public routes.
 */
class App extends Component {
  static contextType = bdcUserContext;

  constructor(props) {
    super(props);
    this.state = {
      bdcUSerFlag: false,
      clientFlag: false,
      filedAt:
        localStorage.getItem("filedAt") !== undefined &&
        localStorage.getItem("filedAt") !== null
          ? localStorage.getItem("filedAt")
          : moment().format("YYYY-MM-DD"),
    };
  }

  componentDidMount() {
    this.setState({
      bdcUSerFlag: isBDCLoggedIn(),
      clientFlag: isClientLoggedIn(),
    });
  }

  render() {
    const { isBDCUser, isClient } = this.context;
    const { bdcUSerFlag, clientFlag } = this.state;
    return (
      <div className="Main">
        <Router>
          <ScrollToTop />
          <Toaster />

          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/login-help" component={ForgotPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route exact path="/Bdc">
              <BdcForm />
            </Route>
            <PrivateRoute
              exact
              path="/"
              component={
                isPgmLoggedIn()
                  ? () => <Redirect to="/leadsmodule" />
                  : bdcUSerFlag === true
                  ? BdcDashboard
                  : isBDCUser
                  ? BdcDashboard
                  : clientFlag === true
                  ? ClientDashboard
                  : isClient
                  ? ClientDashboard
                  : ClientDashboard
              }
            />
            <PrivateRoute exact path="/leadsmodule" component={PGMDashboard} />
            <PrivateRoute
              exact
              path="/search"
              component={(props) => (
                <Search {...props} key={props.location.search} />
              )}
            />
            <PrivateRoute
              exact
              path="/optimizedSearch"
              component={(props) => (
                <OptimizedSearch {...props} key={props.location.search} />
              )}
            />
            <PrivateRoute
              exact
              path="/leadsmodule/optimizedSearch"
              component={(props) => (
                <OptimizedSearchPgm {...props} key={props.location.search} />
              )}
            />
            <PrivateRoute exact path="/form-filing" component={FormFiling} />
            <PrivateRoute path="/catalogues" component={Catalogue} />
            <PrivateRoute path="/selections/show" component={Catalogue} />
            <PrivateRoute path="/client" component={ClientDashboard} />
            <PrivateRoute path="/form-types" component={FormTypes} />
            {/* adding keyword list route (below)  */}
            {isDevelopment() ? (
              <PrivateRoute path="/keyword-types" component={KeywordList} />
            ) : null}
            {isDevelopment() ? (
              <PrivateRoute
                path="/leadsmodule/keyword-types"
                component={KeywordListPgm}
              />
            ) : null}
            {isDevelopment() ? (
              <PrivateRoute
                path="/loan-document"
                component={LoanDocumentFetch}
              />
            ) : null}
            <PrivateRoute path="/ciks" component={CikList} />
            <Route component={NoMatch} />
          </Switch>
        </Router>
      </div>
    );
  }
}

// App.contextType = bdcUserContext;
/**
 * Middleware for private routes.
 */
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      let user = isLoggedIn();
      if (user && isLoggedInDE()) {
        return <Component {...props} user={user} />;
      }
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      );
    }}
  />
);

/**
 * 404: No match route
 */
const NoMatch = ({ location }) => (
  <div className="text-center mt-5 mb-5">
    <code>
      <h3>No match for {location.pathname}</h3>
      <hr />
      <p>The link is broken or the page has been moved.</p>
      <p>
        <a href="/">Got to dashboard</a>
      </p>
    </code>
  </div>
);

// Scroll To Top on Navigation
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default App;
